module.exports = __webpack_public_path__ + "img/kush_puffdaddy.gm.4bfd60e.png";